const { indentStatusList, indentStatusMapping } = require('pando-constants');
const StatusUtils = require('./base');

module.exports = new StatusUtils(indentStatusList, indentStatusMapping);
